export var buttonSchema = "iglu:uk.co.mytutor/button_clicked/jsonschema/1-0-0";
export var cognitoUserSchema = "iglu:uk.co.mytutor/cognito_user_and_roles/jsonschema/1-0-0";
export var coreUserSchema = "iglu:uk.co.mytutor/user/jsonschema/1-0-1";
export var lessonSchema = "iglu:uk.co.mytutor/lesson/jsonschema/1-0-0";
export var opportunitySchema = "iglu:uk.co.mytutor/opportunity/jsonschema/1-0-0";
export var tutorSchema = "iglu:uk.co.mytutor/contextual_tutor/jsonschema/1-0-0";
export var subscriptionSchema = "iglu:uk.co.mytutor/subscription/jsonschema/1-0-0";
export var requestSchema = "iglu:uk.co.mytutor/tutor_request/jsonschema/1-0-0";
export var querySchema = "iglu:uk.co.mytutor/filter_applied/jsonschema/1-0-0";
export var globalTrackerName = "mytutor-web-tracker";
export var hiveAppId = "".concat(process.env.NEXT_PUBLIC_APP_ENVIRONMENT, "-app-mytutor-frontend");
